<div class="full-flex-height justify-content-center align-items-center flex-row innerAppButton appButtons">
   <!-- 
   <a
      *ngIf="isPricingManagerAdmin"
      href="./vetcor-pricing/admin-requests"
      class="box mr-5">
      <div class="card">
         <div class="card-body">
            <h1 class="card-title ico text-center appButton-teal">
               <i class="fa fa-comments-dollar"></i>
            </h1>
            <h4 class="text-center">Admin Code Requests</h4>
         </div>
      </div>
   </a> -->
   <a
      href="./vetcor-pricing/hospital-pricing"
      class="box mr-5">
      <div class="card">
         <div class="card-body">
            <h1 class="card-title ico text-center appButton-teal">
               <i class="fa fa-comments-dollar"></i>
            </h1>
            <h4 class="text-center">Hospital Pricing</h4>
         </div>
      </div>
   </a>
   <a
      *ngIf="isPricingManagerCaptain"
      href="./vetcor-pricing/admin"
      class="box mr-5">
      <div class="card">
         <div class="card-body">
            <h1 class="card-title ico text-center appButton-teal">
               <i class="fa fa-user-cog"></i>
            </h1>
            <h4 class="text-center">Cycle Admin</h4>
         </div>
      </div>
   </a>
   <a
      *ngIf="isPricingManagerAdmin"
      href="./vetcor-pricing/admin-requests"
      class="box mr-5">
      <div class="card">
         <div class="card-body">
            <h1 class="card-title ico text-center appButton-teal">
               <i class="fa fa-comments-dollar"></i>
            </h1>
            <h4 class="text-center">Admin Request Review</h4>
         </div>
      </div>
   </a>
</div>
